import PropTypes from "prop-types";

export const ClinicalSignificanceFieldsType = PropTypes.shape({
  citation: PropTypes.arrayOf(
    PropTypes.shape({
      db: PropTypes.string,
      id: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  modeOfInheritance: PropTypes.string,
  clinicalSignificanceDescription: PropTypes.string,
  comment: PropTypes.string,
});

export const AssertionCriteriaType = PropTypes.shape({
  citation: PropTypes.shape({
    db: PropTypes.string,
    id: PropTypes.string,
  }),
  method: PropTypes.string,
});

export const ConditionSetType = PropTypes.shape({
  condition: PropTypes.arrayOf(
    PropTypes.shape({
      db: PropTypes.string,
      id: PropTypes.string,
    })
  ),
});

export const ObservedInType = PropTypes.arrayOf(
  PropTypes.shape({
    affectedStatus: PropTypes.string,
    alleleOrigin: PropTypes.string,
    clinicalFeatures: [],
    clinicalFeaturesComment: PropTypes.string,
    collectionMethod: PropTypes.string,
    numberOfIndividuals: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    structVarMethodType: PropTypes.string,
  })
);

export const ClinvarSubmissionType = PropTypes.shape({
  classification: {
    clinvarSubmission: [
      {
        assertionCriteria: AssertionCriteriaType,
        clinicalSignificance: ClinicalSignificanceFieldsType,
        conditionSet: ConditionSetType,
        observedIn: ObservedInType,
        recordStatus: PropTypes.string,
        releaseStatus: PropTypes.string,
        variantSet: {
          variant: [
            {
              hgvs: PropTypes.string,
            },
          ],
        },
      },
    ],
  },
  variant_id: PropTypes.number,
  submission_id: PropTypes.string,
  status: PropTypes.string,
  errors: null,
  created_at: PropTypes.string,
  updated_at: PropTypes.string,
  clinvar_accession: PropTypes.string,
});

export const ClassificationType = PropTypes.shape({
  submissionName: PropTypes.string,
  behalfOrgId: PropTypes.string,
  clinvarSubmission: PropTypes.arrayOf(
    PropTypes.shape({
      assertionCriteria: AssertionCriteriaType,
      clinicalSignificance: ClinicalSignificanceFieldsType,
      recordStatus: PropTypes.string,
      releaseStatus: PropTypes.string,
      clinvarAccession: PropTypes.string,
      localID: PropTypes.string,
      localKey: PropTypes.string,
      conditionSet: ConditionSetType,
      variantSet: PropTypes.shape({
        variant: PropTypes.arrayOf(
          PropTypes.shape({
            hgvs: PropTypes.string,
            chromosomeCoordinates: PropTypes.shape({
              // accession: "",
              alternateAllele: PropTypes.string,
              assembly: PropTypes.string,
              // chromosome: "",
              // innerStart: 0,
              // innerStop: 0,
              // outerStart: 0,
              // outerStop: 0,
              referenceAllele: PropTypes.string,
              start: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
              stop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
              // variantLength: 0,
            }),
            // copyNumber: "",
            gene: PropTypes.arrayOf(
              PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                symbol: PropTypes.string,
              })
            ),
            // referenceCopyNumber: 0,
            variantType: PropTypes.string,
          })
        ),
      }),
    })
  ),
});

export const ChromosomeCoordinatesType = PropTypes.shape({
  chr: PropTypes.string,
  start: PropTypes.number,
  ref: PropTypes.string,
  alt: PropTypes.string,
  genome: PropTypes.string,
});

export const VariantSetType = PropTypes.shape({
  variant: PropTypes.arrayOf(
    PropTypes.shape({
      chromosomeCoordinates: PropTypes.shape({
        accession: PropTypes.string,
        alternateAllele: PropTypes.string,
        assembly: PropTypes.string,
        chromosome: PropTypes.string,
        innerStart: PropTypes.number,
        innerStop: PropTypes.number,
        outerStart: PropTypes.number,
        outerStop: PropTypes.number,
        referenceAllele: PropTypes.string,
        start: PropTypes.number,
        stop: PropTypes.number,
        variantLength: PropTypes.number,
      }),
      copyNumber: PropTypes.string,
      hgvs: PropTypes.string,
      referenceCopyNumber: PropTypes.string,
      variantType: PropTypes.string,
      gene: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          symbol: PropTypes.string,
        })
      ),
    })
  ),
});
